// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

/**
 * Sortable column keys for the Triage Queue.
 *
 * 'name' is a Patient-native SearchParameter (family) used on the Ineligible tab.
 * It lives here alongside the Observation-backed column keys because
 * useTriageQueueUrlState parses from this tuple.
 */
export const TRIAGE_SORT_COLUMN_KEYS = [
  'stop-bang',
  'epworth',
  'bmi',
  'age',
  'exclusions',
  'comorbidities',
  'recommendation',
  'insurance',
  'name',
  'ahi',
  'ahiCentral',
  'totalSleepTime',
  'validSleepTime',
  'satBelow88',
  'meanNadir',
  'intakeDate',
  'systemStatus',
] as const;

export type TriageSortColumnKey = (typeof TRIAGE_SORT_COLUMN_KEYS)[number];

export type TriageSortDirection = 'asc' | 'desc';

export interface TriageSortState {
  column: TriageSortColumnKey;
  direction: TriageSortDirection;
}
